import Glide, {Autoplay} from '@glidejs/glide/dist/glide.modular.esm'; // tslint:disable-line
import '@glidejs/glide/src/assets/sass/glide.core.scss'; // tslint:disable-line
import '@glidejs/glide/src/assets/sass/glide.theme.scss'; // tslint:disable-line

import './slideshow.pcss';

export class Slideshow {
  glide: Glide;

  constructor() {
    this.glide = new Glide('.glide', {
      autoplay: 5000,
      classes: {
        activeSlide: 'slideshow__slide--active',
      },
      type: 'carousel',
    }).mount({
      Autoplay,
    });
  }

  destroy() {
    this.glide.destroy();
  }
}
